import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { isSSR } from 'src/helpers/ssr';
import MobileComponent from './MobileComponent';
import MobileBackButton from './MobileBackButton';
import Container from '../Container';
import { HOTEL_MOBILE_PAGES } from '../../constants';

import styles from './mobilePage.module.css';

class MobilePage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onBackPressed = this.onBackPressed.bind(this);
  }

  componentDidMount() {
    this.backBtnPressed = false;
    window.history.pushState(null, document.title, document.location.href);
    window.addEventListener('popstate', this.onBackPressed);
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.onBackPressed);
    if (!this.backBtnPressed) {
      window.history.back();
    }
  }

  onBackPressed() {
    const { goBack } = this.props;
    this.backBtnPressed = true;
    goBack();
  }

  render() {
    const { goBack, page, isFullscreen } = this.props;
    return !isSSR || (isSSR && !page === HOTEL_MOBILE_PAGES.SEARCHER) ? (
      <div className={styles.container}>
        <div
          className={classnames({
            [styles.buttonContainer]: !isFullscreen,
            [styles.buttonContainerAbsolute]: isFullscreen,
          })}
        >
          <MobileBackButton onClick={goBack} />
        </div>
        {isFullscreen ? (
          <MobileComponent name={page} />
        ) : (
          <Container isMobile marginBottom={32}>
            <MobileComponent name={page} />
          </Container>
        )}
      </div>
    ) : null;
  }
}

MobilePage.defaultProps = {
  isFullscreen: false,
};

MobilePage.propTypes = {
  goBack: PropTypes.func.isRequired,
  page: PropTypes.string.isRequired,
  isFullscreen: PropTypes.bool,
};

export default MobilePage;
